import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-24 bg-[#1a0a0f] text-[color:var(--ivory-2)]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <div className="font-display text-2xl text-[color:var(--gold-2)]">Shubh Muhurat</div>
          <p className="text-sm mt-3 text-neutral-300 leading-relaxed">India's boutique marketplace for banquet halls, lawns, caterers and decor — curated for grand weddings & receptions.</p>
          <div className="flex gap-3 mt-5 text-neutral-300">
            <a href="#" aria-label="Instagram"><Instagram className="w-5 h-5"/></a>
            <a href="#" aria-label="Facebook"><Facebook className="w-5 h-5"/></a>
            <a href="#" aria-label="YouTube"><Youtube className="w-5 h-5"/></a>
          </div>
        </div>
        <div>
          <div className="text-xs tracking-widest-2 uppercase text-[color:var(--gold-2)] mb-4">Explore</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/properties">All Venues</Link></li>
            <li><Link to="/highlighted">Highlighted</Link></li>
            <li><Link to="/blogs">Blogs</Link></li>
            <li><Link to="/contact">Contact us</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs tracking-widest-2 uppercase text-[color:var(--gold-2)] mb-4">For Owners</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/register">List your venue</Link></li>
            <li><Link to="/owner">Owner Dashboard</Link></li>
            <li><Link to="/pricing">Subscription Plans</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs tracking-widest-2 uppercase text-[color:var(--gold-2)] mb-4">Reach us</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2"><Phone className="w-4 h-4"/> +91 98000 00000</li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4"/> hello@shubhmuhurat.in</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-neutral-400">
        © {new Date().getFullYear()} Shubh Muhurat. Crafted for India's happiest days.
      </div>
    </footer>
  );
}
